import screenfull from 'screenfull';
import { safeJsonParse } from '@/app-shared/utils/tool';
const playerMixins = {
  data() {
    return {
      initSuccess: false, // 是否初始化成功
      changeTime: null, // 记录时间
      defaultVoice: 0 // 记录静音之前的声音
    };
  },
  computed: {
    isFullScreenSupported() {
      return screenfull.isEnabled;
    },
    permissionValueObj() {
      return this.$domainStore.state.roomBaseServer?.permissionValueObj || {};
    },
    // 获取后台预定义的清晰度文本映射关系
    customeQualityMapping() {
      return safeJsonParse(this.permissionValueObj['live_player_quality_mapping']);
    }
  },

  methods: {
    // 试看的权限
    getShiPreview() {
      const { webinar } = this.roomBaseServer.state.watchInitData;
      const authType = webinar.verify;
      if (this.agreement) {
        this.authText = this.$t('appointment.appointment_1025');
      } else if (authType == 1) {
        this.authText = webinar.verify_tip || this.$t('other.other_1002');
      } else if (authType == 2) {
        this.authText = webinar.verify_tip || this.$t('appointment.appointment_1002');
      } else if (authType == 3) {
        this.authText = webinar.verify_tip || this.$t('appointment.appointment_1010');
      } else if (authType == 4) {
        this.authText = webinar.verify_tip || this.$t('other.other_1003');
      } else if (authType == 6) {
        this.authText = 6;
      }
    },
    listenEvents() {
      // 退出页面时记录历史时间 TODO 配置是否支持断点续播的逻辑
      if (this.subscribeServer.state.isChangeOrder && this.isWarnPreview) return;
      if (this.playerServer.state.type === 'vod' && !this.isTryPreview) {
        window.addEventListener('beforeunload', () => {
          this.endTime = this.playerServer.getCurrentTime(() => {
            console.log('获取当前视频播放时间失败----------');
          });
          this.totalTime = this.playerServer.getDuration(() => {
            console.log('获取视频总时长失败');
          });
          if (this.isWarnPreview) {
            console.log(this.endTime);
            window.sessionStorage.setItem('recordIds', this.warmUpVideoList.join(','));
            if (this.warmUpVideoList[this.initIndex] === this.warmUpVideoList[this.playIndex]) {
              window.localStorage.setItem(this.warmUpVideoList[this.playIndex], this.endTime);
              window.localStorage.setItem('warm_recordId', this.warmUpVideoList[this.playIndex]);
            }
          } else {
            const curLocalHistoryTime = window.localStorage.getItem(
              this.roomBaseServer.state.watchInitData.paas_record_id
            );
            if (!curLocalHistoryTime && this.recordHistoryTime) {
              return;
            }
            window.localStorage.setItem(this.vodOption.recordId, this.endTime);
          }
        });
      }
      if (screenfull.isEnabled) {
        screenfull.on('error', event => {
          console.log(event, this.playIndex, this.initIndex, '???我是全屏错误');
        });
        screenfull.on('change', ev => {
          this.isFullscreen = !this.isFullscreen;
        });
      }
      clearTimeout(this.hoverVideoTimer);
      this.hoverVideoTimer = setTimeout(() => {
        this.hoveVideo = false;
      }, 3000);
      window.addEventListener('keydown', event => {
        let e = event || window.event || arguments.callee.caller.arguments[0];
        console.log('keydown e:', e?.target?.nodeName, e);
        if (e.keyCode === 32 && e?.target?.nodeName !== 'INPUT') {
          // 避免影响问卷输入框无法录入空格
          // 空格键
          this.startPlay();
          if (e.preventDefault) {
            e.preventDefault();
          } else {
            window.event.returnValue = false;
          }
        } else if (e.keyCode === 38) {
          //  "Numpad8" ("ArrowUp") 向上箭头
          if (this.voice >= 100) {
            this.voice = 100;
            return;
          }
          this.voice = this.voice + 2;
        } else if (e.keyCode === 40) {
          // "Numpad2" ("ArrowDown") 向下箭头
          if (this.voice <= 0) {
            this.voice = 0;
            return;
          }
          this.voice = this.voice - 2;
        } else if (e.keyCode === 173) {
          console.log('11111静音');
        }
      });
    },
    getListenPlayer() {
      //  直播开始
      this.playerServer.$on('play_ext', () => {
        // 监听播放状态
        this.$domainStore.state.playerServer.isPlaying = true;
        this.isShowPoster = false;
        this.isVodEnd = false;
        if (this.isWarnPreview) {
          this.subscribeServer.state.isPlaying = true;
        }
        console.log('%c播放器 PLAY', 'color:blue');
      });
      this.playerServer.$on('pause', () => {
        // 监听暂停状态
        this.$domainStore.state.playerServer.isPlaying = false;
        console.log('%c播放器 PAUSE', 'color:blue');
      });
      // 视频清晰度发生改变----卡顿切换清晰度时触发
      this.playerServer.$on('definitionchange', () => {
        this.loading = true;
        console.log('%c播放器 DEFINITION_CHANGE', 'color:blue');
      });
      // 卡顿
      this.playerServer.$on('lagreport', () => {
        this.loading = true;
        console.log('%c播放器 LAG_REPORT', 'color:blue');
      });

      // 卡顿恢复
      this.playerServer.$on('lagrecover', () => {
        this.loading = false;
        console.log('%c播放器 LAG_RECOVER', 'color:blue');
      });

      // 视频加载完毕
      this.playerServer.$on('loadeddata_ext', () => {
        this.loading = false;
        console.log('加载完毕第一次进入');
        if (this.isWarnPreview) {
          // 如果暖场视频长度大于1，才初始化二个播放器。将isFirstEnterPlayer在初始化第一个之后置为true
          if (this.warmUpVideoList.length > 1 && !this.subscribeServer.state.isFirstEnterPlayer) {
            this.subscribeServer.state.isFirstEnterPlayer = true;
            //initPlayerIndex是从0开始计数的 如果initPlayerIndex小于暖场视频长度-1，就加+1，否则就从第0个开始初始化
            if (this.initPlayerIndex < this.warmUpVideoList.length - 1) {
              this.subscribeServer.state.initIndex++;
            } else {
              this.subscribeServer.state.initIndex = 0;
            }
            // 更新循环列表更新
            this.subscribeServer.setWarmVideoList(
              this.warmUpVideoList[this.subscribeServer.state.initIndex],
              true
            );
          }
        }
      });
      // 视频错误
      this.playerServer.$on('error', () => {
        this.loading = true;
      });
      // 视频播放完毕
      this.playerServer.$on('ended', () => {
        // 监听播放完毕状态
        console.log('pc-播放完毕', this.warmUpVideoList.length);
        // console.log('-----------playIndex--------=========', this.playIndex);
        // console.log(
        //   '-----------initIndex--------=========',
        //   this.initIndex,
        //   this.roomBaseServer.state.warmUpVideo.warmup_player_type
        // );
        // console.log(
        //   '-----------initPlayerIndex--------=========',
        //   this.initPlayerIndex,
        //   this.playerServer.getCurrentTime(() => {
        //     console.log('获取当前视频播放时间失败----------');
        //   }),
        //   this.playerServer.getDuration(() => {
        //     console.log('获取视频总时长失败');
        //   })
        // );

        // 如果是暖场视频
        if (this.isWarnPreview) {
          // 如果是第一次进入页面，刷新页面导致，就不走下面的逻辑

          this.isShowPoster = true;
          this.$domainStore.state.playerServer.isPlaying = false;
          if (this.warmUpVideoList.length == 1) {
            // 如果只有一个暖场视频，并且开启了循环播放，就自动调用播放方法
            if (this.roomBaseServer.state.warmUpVideo.warmup_player_type == 2) {
              this.playerServer.play();
            } else {
              if (document.pictureInPictureElement) {
                document.exitPictureInPicture();
              }
            }
          } else {
            if (
              this.playIndex == this.warmUpVideoList.length - 1 &&
              this.roomBaseServer.state.warmUpVideo.warmup_player_type == 1
            ) {
              //暖场视频 播放到最后一个结束 关闭小窗
              if (document.pictureInPictureElement) {
                document.exitPictureInPicture();
              }
            }
            // 多个暖场视频的逻辑，如果大于2，才播放完毕一个销毁一个，初始化下一个
            if (this.warmUpVideoList.length > 2) {
              this.playerServer.destroy();
            }
            // 将当前存的断点续播时间清除
            window.localStorage.removeItem(this.warmUpVideoList[this.playIndex]);
            window.localStorage.removeItem('warm_recordId');
            // 如果播放完的playIndex 小于暖场视频长度-1，就+1，否则就从0开始播放
            if (this.playIndex < this.warmUpVideoList.length - 1) {
              this.subscribeServer.state.playIndex++;
            } else {
              this.subscribeServer.state.playIndex = 0;
            }
            // 暖场视频循环的列表，只存2个值，播放完第一个，移除第一个，并往上增加第三个的值
            this.subscribeServer.setWarmVideoList('', false);
            // 如果初始化完的initPlayerIndex 小于暖场视频长度-1，就+1，否则就从0开始播放
            if (this.initPlayerIndex < this.warmUpVideoList.length - 1) {
              this.subscribeServer.state.initIndex++;
              this.subscribeServer.setWarmVideoList(
                this.warmUpVideoList[this.subscribeServer.state.initIndex],
                true
              );
            } else {
              this.subscribeServer.state.initIndex = 0;
              this.subscribeServer.setWarmVideoList(this.warmUpVideoList[0], true);
            }
          }
        } else {
          this.isShowPoster = true;
          this.isVodEnd = true;
          if (this.isVisibleMiniElement) {
            // 如果回放时没有文档，就不用重置最小值
            this.roomBaseServer.setChangeElement('doc');
          }
          this.displayMode = 'normal';

          if (document.pictureInPictureElement) {
            document.exitPictureInPicture();
          }
          this.roomBaseServer.state.watchInitData.paas_record_id &&
            localStorage.removeItem(this.roomBaseServer.state.watchInitData.paas_record_id);
        }
      });

      // 结束直播
      this.playerServer.$on('live_over', data => {
        console.log(data);
        this.playerServer && this.playerServer.destroy();
        this.isLivingEnd = true;
        if (document.pictureInPictureElement) {
          document.exitPictureInPicture();
        }
      });

      // 自动播放成功
      this.playerServer.$on('autoplaySuccess', data => {
        console.log('playerServer 触发 autoplaySuccess, isMuted:', data?.isMuted);
        this.playerServer.state.isPlaying = true;
      });

      // 支付成功
      this.playerServer.$on('pay_success', data => {
        const userInfo = this.$domainStore.state.userServer.userInfo;
        if (data.target_id == userInfo.user_id) {
          this.$message({
            message: this.$t('common.common_1005'),
            showClose: true,
            type: 'success',
            customClass: 'zdy-info-box'
          });
          this.feeAuth({ type: 3 });
          this.closePayFee();
        }
      });
    },
    controllerMouseLeave() {
      clearTimeout(this.hoverVideoTimer);
      this.hoverVideoTimer = setTimeout(() => {
        this.hoveVideo = false;
      }, 3000);
    },
    controllerMouseEnter() {
      clearTimeout(this.hoverVideoTimer);
      if (this.isEmbedPlayerIconHidden) {
        this.hoveVideo = false;
      } else {
        this.hoveVideo = true;
      }
    },
    wrapEnter() {
      if (this.isEmbedPlayerIconHidden) {
        this.hoveVideo = false;
      } else {
        this.hoveVideo = true;
      }
    },
    wrapLeave() {
      clearTimeout(this.hoverVideoTimer);
      this.hoverVideoTimer = setTimeout(() => {
        this.hoveVideo = false;
      }, 3000);
    },
    /**
     * 发送弹幕
     */
    addBarrage(text) {
      try {
        this.playerServer &&
          this.playerServer.addBarrage(text, e => {
            console.log(e, '添加弹幕失败');
          });
      } catch (e) {
        console.log(e);
      }
    },
    // 设置默认视频清晰度
    setDefaultQuality() {
      let defaultDefinition;
      if (sessionStorage.getItem('localQualityValue')) {
        defaultDefinition = sessionStorage.getItem('localQualityValue');
      } else {
        defaultDefinition = this.definitionConfig;
      }
      return defaultDefinition;
    },
    // 获取清晰度列表和当前清晰度
    getQualitys() {
      const qualityList = this.playerServer ? this.playerServer.getQualitys() : [];
      if (this.isAudio) {
        this.qualitysList = qualityList.filter(item => item.def === 'same');
        return;
      } else {
        const defs = [];
        // 如果是回放，且配置了不显示音频入口, 过滤掉
        if (this.playerServer.state.type == 'vod' && !this.playerOtherOptions.record_audio)
          defs.push('a');
        // 如果配置了隐藏原画, 且可选列表中除了原画还有其它的清晰度源，过滤掉
        const otherIdx = qualityList.findIndex(item => item.def != 'a' && item.def != 'same');
        if (this.roomBaseServer.state.configList['live_hidden_same'] == 1 && otherIdx > -1) {
          defs.push('same');
        }
        if (defs.length > 0) {
          this.qualitysList = qualityList.filter(item => !defs.includes(item.def));
        } else {
          this.qualitysList = qualityList;
        }
      }
      this.currentQualitys = this.playerServer.getCurrentQuality();
      this.$nextTick(() => {
        if (this.currentQualitys.def == 'a') {
          console.log('音频进入');
          this.audioStatus = true;
        } else {
          console.log('no----音频---进入');
          this.audioStatus = false;
        }
      });
    },
    // 获取倍速列表和当前倍速
    getInitSpeed() {
      const UsableSpeed = this.playerServer.getUsableSpeed(() => {
        console.log('获取倍速失败');
      });
      this.UsableSpeed =
        UsableSpeed &&
        UsableSpeed.filter(value => {
          return [2, 1.75, 1.5, 1.25, 1, 0.75].includes(value);
        });
      console.log('获取倍速', this.UsableSpeed);
      if (sessionStorage.getItem('localSpeedValue') && this.playerOtherOptions.speed) {
        this.currentSpeed = parseFloat(sessionStorage.getItem('localSpeedValue'));
        let suc = true;
        this.playerServer.setPlaySpeed(this.currentSpeed, () => (suc = false));
        if (suc) {
          console.log('设置成功,sucess');
        } else {
          console.log('设置失败,falil');
          this.currentSpeed = 1;
        }
      } else {
        this.currentSpeed = 1;
      }
    },
    // 修改视频清晰度
    changeQualitys(item) {
      console.log(item);
      let sucess = true;
      this.playerServer.setQuality(item, err => {
        sucess = false;
        console.log('设置画质失败 ', err); // object 类型，{ code: 错误码, message: "", data: {} }
      });
      if (sucess) {
        console.log('设置画质成功--------', item);
        if (item.def == 'a') {
          this.audioStatus = true;
        } else {
          this.audioStatus = false;
        }
        this.isSetQuality = true;
        this.currentQualitys = item;
        sessionStorage.setItem('localQualityValue', item.def);
        this.setChange();
      }
    },
    // 修改视频倍速
    changeSpeed(item) {
      let sucess = true;
      this.playerServer.setPlaySpeed(item, err => {
        console.log(err, '切换失败');
        sucess = false;
      });
      if (sucess) {
        console.log('设置倍速成功--------', item);
        sessionStorage.setItem('localSpeedValue', item);
        this.isSetSpeed = true;
        this.currentSpeed = item;
        this.setChange();
      }
    },
    initSlider() {
      this.playerServer.$on('timeupdate', () => {
        if (this._isSetingCurrentTime) return;
        this.currentTime = this.playerServer.getCurrentTime(() => {
          console.log('获取当前视频播放时间失败----------');
        });
        this.sliderVal = (this.currentTime / this.totalTime) * 100;
        // 派发播放器时间更新事件，通知章节当前播放的时间节点
        this.playerServer.emitChapterTimeUpdate(this.currentTime);
      });
    },
    // 设置播放时间
    setVideoCurrentTime(val) {
      if (!this.playerServer) return;

      console.log('video val', val);

      this.playerServer.setCurrentTime(val, () => {
        this.$message({
          type: 'error',
          message: '设置当前时间失败,请稍后重试'
        });
        console.error('设置当前播放时间失败');
      });
      this._isSetingCurrentTime = false;
    },
    // 开启/关闭弹幕
    openBarrage() {
      if (this.playerServer) {
        this.danmuIsOpen = !this.danmuIsOpen;
        this.danmuIsOpen ? this.playerServer.openBarrage() : this.playerServer.closeBarrage();
        sessionStorage.setItem('vhall_player_barrageOpen', this.danmuIsOpen ? 1 : '');
      }
    },
    enterFullscreen() {
      if (screenfull.isEnabled) {
        screenfull.toggle(this.$refs.playerWatch);
      }
    },
    setChange() {
      if (this.changeTime) {
        clearTimeout(this.changeTime);
      }
      this.changeTime = setTimeout(() => {
        this.isSetSpeed = false;
        this.isSetQuality = false;
      }, 2000);
    },
    formatQualityText(val) {
      let text;
      switch (val) {
        case 'same':
        case 'origin':
        case 'origin_wz264':
          text = this.customeQualityMapping?.[val] || this.$t('player.player_1002');
          break;
        case '720p':
        case '720sp':
          text = this.customeQualityMapping?.[val] || this.$t('player.player_1005');
          break;
        case '480p':
        case '480sp':
          text = this.customeQualityMapping?.[val] || this.$t('player.player_1003');
          break;
        case 'a':
        case 'as':
          text = this.customeQualityMapping?.[val] || this.$t('player.player_1006');
          break;
        case '360p':
        case '360sp':
          text = this.customeQualityMapping?.[val] || this.$t('player.player_1004');
          break;
        default:
          text = this.$t('player.player_1004');
      }
      return text;
    }
  }
};
export default playerMixins;
